import { Routes } from '@angular/router';

// Dev-only routes (e.g. the /ui-kit shared-component gallery).
// In production builds this file is swapped for dev-routes.prod.ts via
// angular.json `fileReplacements`, so the code below is never bundled.
export const devOnlyRoutes: Routes = [
  {
    path: 'ui-kit',
    title: 'UI Kit',
    loadComponent: () => import('./features/ui-kit/ui-kit.component').then((m) => m.UiKitComponent),
  },
];
